import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';
import { isDefined, isEqual } from '@fi-shared/utils';

@Component({
    selector: 'fi-wrapper-grid',
    templateUrl: './fi-wrapper-grid.component.html',
    styleUrls: ['./fi-wrapper-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-grid' },
    standalone: false,
})
export class FiWrapperGridComponent<T extends { Id: number }> {
    @Input() items: T[];
    @Input() selectedItems: T[];
    @Input() itemNameProperty: string;
    @Input() isNestedList: boolean;
    @Input() nestedArrayPropertyName: string;
    @Input() isMultiSelect: boolean = true;
    @Output() selectedItemsChange: EventEmitter<T[]> = new EventEmitter<T[]>();
    @ContentChild('imageContentTemplateRef') imageContentTemplateRef: TemplateRef<any>;
    @ContentChild('displayValueContentTemplateRef') displayValueContentTemplateRef: TemplateRef<any>;
    @ContentChild('displayAdditionalValueContentTemplateRef')
    displayAdditionalValueContentTemplateRef: TemplateRef<any>;
    @ContentChild('favoriteContentTemplateRef') favoriteContentTemplateRef: TemplateRef<any>;
    @ContentChild('superAdminContentTemplateRef') superAdminContentTemplateRef: TemplateRef<any>;
    
    expandDetailItemActive: T;

    toggleChildItemsVisibility(item: T) {
        if (!isDefined(this.expandDetailItemActive)) {
            this.expandDetailItemActive = item;
            return;
        }
        if (isEqual(this.expandDetailItemActive, item))
            this.expandDetailItemActive = isEqual(this.expandDetailItemActive, item) ? undefined : item;
    }

    getGridNestedItems(item: T): T[] {
        if (isEqual(this.expandDetailItemActive, item))
            return !!item[this.nestedArrayPropertyName]?.length
                ? [item, ...item[this.nestedArrayPropertyName]]
                : [item];
        return [item];
    }

    isItemSelected(item: T): boolean {
        return !!this.selectedItems.find((selectedItem: T) => selectedItem.Id === item.Id);
    }

    toggleItemSelection(item: T) {
        const itemIndex: number = this.selectedItems.findIndex((selectedItem: T) => {
            return selectedItem.Id === item.Id;
        });

        if (!this.isMultiSelect) {
            this.selectedItems = itemIndex === -1 ? [item] : [];
            this.selectedItemsChange.emit(this.selectedItems);
            return;
        }

        if (itemIndex === -1) {
            this.selectedItems.push(item);
        } else {
            this.selectedItems.splice(itemIndex, 1);
        }
        this.selectedItemsChange.emit(this.selectedItems);
    }
}
